import { $ } from './dom';
import { warn } from './log';
import { parseZoned } from './time';
import { resolveZone } from './zone';

export interface EventContext {
  zone: string | null;
  start: Date | null;
  end: Date | null;
  title: string;
}

/** What every feature receives when the context itself failed — behaves exactly like an empty page. */
export const EMPTY_CONTEXT: EventContext = { zone: null, start: null, end: null, title: '' };

/** The one event on the page — parsed once, shared by every feature. Dates are read from whichever element carries them. */
export const eventContext = (): EventContext => {
  const startEl = $('[data-event-start]');
  const endEl = $('[data-event-end]');
  const titleEl = $('[data-event-full]');
  const zone = resolveZone(startEl, endEl);
  const start = parseZoned(startEl?.getAttribute('data-event-start'), zone);
  const end = parseZoned(endEl?.getAttribute('data-event-end'), zone);
  // Loud when a date is present but unreadable; a missing end is valid (calendar defaults to 2 h, list pages carry only starts).
  if ((startEl && !start) || (endEl && !end))
    warn('event dates missing or unreadable →', {
      start: startEl?.getAttribute('data-event-start'),
      end: endEl?.getAttribute('data-event-end'),
      zone,
    });
  return {
    zone,
    start,
    end,
    title: titleEl?.getAttribute('data-event-full')?.trim() || titleEl?.textContent?.trim() || '',
  };
};
